import { isArray } from 'util';

import { FetchAPI, ToastNotificationAPI } from '@philips-emr/tws-components';
import { FetchEvent, MountEvent } from '@philips-emr/tws-core/lib/component/types';
import { HistoryService, HttpService } from '@philips-emr/tws-core/lib/services';

import { Endpoint } from '../constants';

export class ProviderAccreditationPendenciesService {

  public static async getPendencies(nrSeqAccreditation: number, nrSeqUser: number, type: string, steps?: string): Promise<any> {
    const step = steps ? steps : '';
    return await HttpService.get(Endpoint.GET.ACCREDITATION_PENDENCES, { nrSeqAccreditation, nrSeqUser, type, step });
  }

  public static fetchCardPendencies(event: MountEvent, step: string): void {
    const api = event.target as FetchAPI;
    const { nrSeqUser, nrSeqAccreditation } = HistoryService.getCurrentRouteParams();
    api.setParameters({ nrSeqUser, nrSeqAccreditation, step, type: 'R' });
    api.forceFetch();
  }

  public static setMessageToastPendency(toastApi: ToastNotificationAPI, event: FetchEvent): void {
    if (isArray(event.data)) {
      const data = event.data[0];
      const { message } = data;
      toastApi.setMessage(message);
      toastApi.setVisible(true);
    }
  }

}
